/**
 * The code of the choice that stands for every language: the forum's list of
 * languages leads with it when the setting to offer it is on.
 */
export const ANY = 'any';
flarum.reg.add('fof-discussion-language', 'common/utils/any', { ANY: ANY, });